import { render, staticRenderFns } from "./IlluNumber1.vue?vue&type=template&id=2488d4dc&"
import script from "./IlluNumber1.vue?vue&type=script&lang=js&"
export * from "./IlluNumber1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports